module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Return\n            "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [(_vm.isReturnsLoaded) ? _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Your Return has been submitted successfully.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.returns.lodgement_number))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" " + _vm._s(_vm._f("formatDate")(_vm.returns.lodgement_date)))])])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": _vm.returns.invoice_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "color": "red"
    }
  })])])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])]) : _c('div', {
    staticClass: "col-sm-offset-3 col-sm-6 borderDecoration"
  }, [_c('strong', [_vm._v("Sorry it looks like there isn't any details currently in your session.")]), _vm._v(" "), _c('br'), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to dashboard")])])]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "table_name"
    },
    domProps: {
      "value": _vm.returns.table[0].name
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Reference number: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Lodgement date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Invoice:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f2c8f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/return_submit.vue
// module id = 964
// module chunks = 0